module.exports = __webpack_public_path__ + "static/media/edit.56a251b9.svg";